module.exports = "#define GLSLIFY 1\n#ifdef USE_COLOR\n\n\tdiffuseColor.rgb *= vColor;\n\n#endif"


//////////////////
// WEBPACK FOOTER
// ./src/vendor/three/renderers/shaders/ShaderChunk/color_fragment.glsl
// module id = 219
// module chunks = 0